import React, { useEffect, useState } from "react";
import ceo from "./about-img/ceo.png";
import { Link } from "react-router-dom";
import vision from "./about-img/our-vision.jpg";
import "./style.css";
const Founder = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      <div>
        <div class="wrapper" id="cover">
          <img
            src={require("../../Assets/images/924117-overlay.jpg")}
            class="prx"
            style={{ height: "205px", width: "100%" }}
          />
          <h1>
            {rtl
              ? `رسالة المؤسس`
              : fr
              ? "Notre Fondateur"
              : `Founder's Message`}
          </h1>
        </div>
      </div>

      {/* *********************** */}
      <div id="bodycont" class="bg">
        <div class="pagewrap">
          <div class="wrapper grid5">
            <article class="fluid animated fadeInRight">
              <div class="col">
                <div class="left-nav">
                  <ul>
                    <li>
                      <Link to="/about">
                        {rtl
                          ? "مكة والمدينة القابضة المحدودة"
                          : fr
                          ? "Mecque & la Médine Holding LTD"
                          : `Makkah & Al Madinah Holding LTD`}
                      </Link>
                    </li>
                    <li>
                      <Link to="/founder">
                        {rtl
                          ? " رسالة المؤسس"
                          : fr
                          ? "Message du fondateur"
                          : `Founder's Message`}
                      </Link>
                    </li>

                    <li>
                      <strong>
                        {rtl
                          ? "السيرة الذاتية لرئيس مجلس الإدارة"
                          : fr
                          ? "BIOGRAPHIE DU PRÉSIDENT"
                          : "Chairman Biography"}
                      </strong>
                      <p>
                        {rtl ? (
                          <a href="https://docdro.id/hndvwYr" target="_blank">
                            PDF عربي
                          </a>
                        ) : fr ? (
                          <a href="https://docdro.id/NBMNduH" target="_blank">
                            PDF Français
                          </a>
                        ) : (
                          <a href="https://docdro.id/CXEIOk4" target="_blank">
                            PDF English
                          </a>
                        )}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </article>
            {/* ****************************************** */}
            <article class="fluid two animated fadeInDown">
              <h1>
                {rtl
                  ? "رسالة من مؤسسنا السيد سيدي شهيد"
                  : fr
                  ? "UN MESSAGE DE NOTRE FONDATEUR, M. SIDI SHAHID"
                  : `A message from our founder , Mr. Sidi Shahid`}
              </h1>
              <div class="col">
                {/* <h1>Founder's Message</h1> */}
                <div
                  class="imgcont"
                  style={{
                    paddingLeft: "10px",
                    paddingTop: "10px",
                  }}
                >
                  <img
                    src={require("../../Assets/sidi.jpg")}
                    class="crv"
                    style={{
                      width: "215px",
                      height: "400px",
                    }}
                  />
                  <div class="overlay"></div>
                  <p
                    class="note"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <strong>
                      {rtl ? `سيدي شهيد` : fr ? "Sidi Shahid" : "Sidi Shahid"}
                    </strong>
                    {rtl
                      ? "المؤسس والرئيس التنفيذي "
                      : fr
                      ? "Fondateur et PDG"
                      : `Founder & CEO`}
                    <div class="team-scl">
                      <a href="#" title="Twitter" target="_blank">
                        <i class="fas fa-twitter"></i>
                      </a>
                      <a href="#" title="Linekdin" target="_blank">
                        <i class="fas fa-linkedin"></i>
                      </a>
                      {/* <a
                                                href="#"
                                                title="Instagram"
                                                target="_blank"
                                            >
                                                <i class="fa fa-instagram"></i>
                                            </a>
                                            <a
                                                href="#"
                                                title="Facebook"
                                                target="_blank"
                                            >
                                                <i class="fa fa-facebook"></i>
                                            </a> */}
                    </div>
                    {/* <br />
                    <em>(1925-2015)</em> */}
                  </p>
                </div>
                <div
                  style={{
                    background: "white",
                    padding: "0px 15px 15px",
                    borderRadius: "10px",
                  }}
                >
                  <p
                    style={{
                      lineHeight: "30px",
                      textAlign: "justify",
                    }}
                  >
                    {rtl
                      ? `مرحبا بكم في شركتنا القابضة، مكة والمدينة القابضة المحدودة. إنه لشرف عظيم لي أن أقدم هذا الشركة الإسلامية الدولية القابضة. وهي عبارة عن عقد خاص مصمم لخدمة المسلمين وغير المسلمين. وقد تم إنشاؤه لمساعدة أولئك الذين يؤمنون بقيمنا المتمثلة في "المساعدة والمشاركة والرعاية". نحن شعب مسالم يرغب حقا في رؤية عالم واحد يعقد خدمة المواطنين من جميع الثقافات والأديان.
`
                      : fr
                      ? `Bienvenue dans notre holding, Mecque & la Médine Holding LTD. C'est un grand
                      honneur pour moi de présenter au monde ce holding islamique international. Il
                      s'agit d'un holding privé conçu pour servir les musulmans et les non-musulmans.
                      Elle a été créée pour aider ceux qui croient en nos valeurs "d'aide, de partage et
                      de sollicitude". Nous sommes un peuple pacifique qui souhaite réellement voir
                      un holding mondial unique au service des citoyens de toutes cultures et de toutes
                      confessions.`
                      : `Welcome to our Holding, Makkah & Al
                                        Madinah Holding LTD. It is my greatest
                                        honour to introduce this International
                                        Islamic holding to the world. It is a
                                        private holding designed to serve
                                        Muslims and non-Muslims. It has been
                                        created to assist those who believe in
                                        our values of “helping, sharing and
                                        caring”. We are a peaceful people who
                                        truly wish to see a one world holding
                                        that serves citizens of all cultures and
                                        faiths.`}
                  </p>
                  <p>&nbsp;</p>
                  <p
                    style={{
                      lineHeight: "30px",
                      textAlign: "justify",
                    }}
                  >
                    {rtl
                      ? `بصفته المؤسس سيدي شهيد ، يتمتع بخبرة كبيرة في مجال التطوير العقاري والتمويل وتجارة السلع ، من بين مساعي أخرى.
`
                      : fr
                      ? `En tant que fondateur, Sidi Shahid apporte une expérience significative dans le
                      développement immobilier, la finance et le commerce des matières premières,
                      entre autres.`
                      : `As Founder Sidi Shahid brings
                                        significant experience in real estate
                                        development, finance, and commodities
                                        trading, among other endeavors.`}
                  </p>
                  <p>&nbsp;</p>
                  <p
                    style={{
                      lineHeight: "30px",
                      textAlign: "justify",
                    }}
                  >
                    {/* Shahid and his family were
                                        chosen by the Supreme Leader to
                                        establish and manage MMH based in the
                                        United Kingdom. Sidi*/}
                    {rtl
                      ? `السيد سيدي وعائلته هم غالبية المساهمين في صندوق الاستثمار في الأسهم الإسلامية الخاصة ويعملون مباشرة مع قاعدة كبيرة جدا من المستثمرين في جميع أنحاء العالم. تأسست مكة والمدينة القابضة المحدودة  في يوليو 2016 ، وهي شركة مسجلة (رقم 10286040 بموجب قانون الشركات لعام 2006 في إنجلترا وويلز) مع أهداف تجارية ودينية واجتماعية
`
                      : fr
                      ? `M. Sidi et sa famille sont les actionnaires majoritaires de ce fonds
                      d'investissement privé islamique et travaillent directement avec
                      une très large base d'investisseurs dans le monde entier. MMH a
                      été constitué en juillet 2016, et est une société enregistrée (n°
                      10286040 en vertu de la loi sur les sociétés de 2006 en Angleterre
                      et au Pays de Galles) avec des objectifs commerciaux, religieux et
                      de cause sociale.`
                      : `Mr. Sidi and his family are the majority
                                        shareholders in this private Islamic
                                        equity investment fund and work directly
                                        with a very large base of investors
                                        worldwide. MMH was incorporated in July
                                        2016, and is a registered company (No.
                                        10286040 under the Companies Act 2006 in
                                        England and Wales) with commercial,
                                        religious and social cause objectives`}
                  </p>
                  <p>&nbsp;</p>

                  <p
                    style={{
                      lineHeight: "30px",
                      textAlign: "justify",
                    }}
                  >
                    {rtl
                      ? `هذه الفلسفات راسخة الآن داخل منظمتنا على جميع المستويات وستستمر في دفع استراتيجياتنا في السنوات والعقود المقبلة.
`
                      : fr
                      ? `Ces philosophies sont désormais ancrées dans notre organisation à
                      tous les niveaux et continueront de guider nos stratégies dans les
                      années et décennies à venir.`
                      : ` These philosophies are now entrenched
                                        within our organization at all levels
                                        and will continue to drive our
                                        strategies in the years and decades
                                        ahead.`}
                  </p>
                  <p>&nbsp;</p>
                  <p
                    style={{
                      fontSize: "30px",
                      textAlign: "center",
                      color: "#0c473d",
                    }}
                  >
                    {rtl
                      ? `نيابة عن مكة والمدينة القابضة المحدودة   ، نتطلع إلى خدمتك
`
                      : fr
                      ? "Au nom de MMH, nous nous réjouissons de vous servir."
                      : ` On behalf of MMH, we look forward to
                                        serving you`}
                  </p>
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                  {/* <img src="../images/sig.png" /> */}

                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                </div>
              </div>
            </article>
            {/* ****************************************** */}
            <article class="fluid animated fadeInLeft">
              <div class="col">
                <h3 style={{ textAlign: "center" }}>
                  {rtl ? "رؤيتنا" : fr ? "Notre Vision" : `Our Vision`}
                </h3>
                <div class="right-box">
                  <img src={vision} class="crv2" />
                  <h1 style={{ textAlign: "center" }}>
                    {rtl
                      ? "رؤيتنا وقيمنا"
                      : fr
                      ? "Notre Vision et nos Valeurs"
                      : `Our vision and values`}
                  </h1>

                  <p
                    style={{
                      textAlign: "center",
                      lineHeight: "20px",
                    }}
                  >
                    {rtl
                      ? `سنخدم احتياجات الحكومات الوطنية والمحلية والشركات الكبيرة وكبار المستثمرين الذين يركزون على أفريقيا ، وبعد ذلك ، الشرق الأوسط وجنوب شرق آسيا. سيكون هدفنا هو تحسين نوعية الحياة`
                      : fr
                      ? `Nous répondrons aux besoins des gouvernements nationaux et
                      locaux, des grandes entreprises et des grands investisseurs en
                      nous concentrant sur l'Afrique, puis sur le Moyen-Orient et l'Asie
                      du Sud-Est. Notre objectif sera d'améliorer la qualité de vie`
                      : `We will serve the needs of national and
                                        local governments, large corporations
                                        and major investors focusing on Africa,
                                        and later, the Middle East and Southeast
                                        Asia. Our objective will be to improve
                                        the quality of life`}{" "}
                    <br />
                    <Link to="/other">
                      {rtl
                        ? "اقرأ المزيد..."
                        : fr
                        ? "Lire la suite..."
                        : `Read More...`}
                    </Link>
                  </p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
      {/* *********************** */}
    </>
  );
};

export default Founder;
